import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["Icon"];
import ClimaLight from '@crehana/compass.icons.logos/ClimaLight';
import DesempenoLight from '@crehana/compass.icons.logos/DesempenoLight';
import LearningLight from '@crehana/compass.icons.logos/LearningLight';
import ArrowRandom from '@crehana/compass.icons.outline/ArrowRandom';
import Award from '@crehana/compass.icons.outline/Award';
import BarChart2 from '@crehana/compass.icons.outline/BarChart2';
import Book from '@crehana/compass.icons.outline/Book';
import BookOpen from '@crehana/compass.icons.outline/BookOpen';
import Clock from '@crehana/compass.icons.outline/Clock';
import GraduationCap from '@crehana/compass.icons.outline/GraduationCap';
import Mentorship from '@crehana/compass.icons.outline/Mentorship';
import Report from '@crehana/compass.icons.outline/Report';
import { jsx as _jsx } from "react/jsx-runtime";
// Safe icon component wrapper
var SafeIcon = function SafeIcon(_ref) {
  var Icon = _ref.Icon,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!Icon) {
    return null;
  }
  return /*#__PURE__*/_jsx(Icon, _objectSpread({}, props));
};
var APPEND_DATA = [{
  variant: 'alert',
  Icon: /*#__PURE__*/_jsx(BarChart2, {
    className: "tw-text-current",
    size: 24
  }, "Hana_Results_And_Data_Analysis")
}, {
  variant: 'success',
  Icon: /*#__PURE__*/_jsx(SafeIcon, {
    Icon: Report,
    className: "tw-text-current",
    size: 24
  }, "Hana_Categories_Report")
}, {
  variant: 'info',
  Icon: /*#__PURE__*/_jsx(SafeIcon, {
    Icon: Mentorship,
    className: "tw-text-current",
    size: 24
  }, "Hana_Categories_Helpdesk")
}, {
  variant: 'primary',
  Icon: /*#__PURE__*/_jsx(SafeIcon, {
    Icon: BookOpen,
    className: "tw-text-current",
    size: 24
  }, "Hana_Categories_Courses_Recommendations")
}, {
  variant: 'alert',
  Icon: /*#__PURE__*/_jsx(SafeIcon, {
    Icon: GraduationCap,
    className: "tw-text-current",
    size: 24
  }, "Hana_Categories_Course_Assignments")
}, {
  variant: 'success',
  Icon: /*#__PURE__*/_jsx(SafeIcon, {
    Icon: Book,
    className: "tw-text-current",
    size: 24
  }, "Hana_Categories_Course_Recommendations")
}, {
  variant: 'info',
  Icon: /*#__PURE__*/_jsx(SafeIcon, {
    Icon: Clock,
    className: "tw-text-current",
    size: 24
  }, "Hana_Categories_PID")
}, {
  variant: 'primary',
  Icon: /*#__PURE__*/_jsx(SafeIcon, {
    Icon: Award,
    className: "tw-text-current",
    size: 24
  }, "Hana_Categories_Goal_Recommendations")
}, {
  variant: 'alert',
  Icon: /*#__PURE__*/_jsx(SafeIcon, {
    Icon: ArrowRandom,
    className: "tw-text-current",
    size: 24
  }, "Hana_Categories_ArrowRandom")
}, {
  variant: 'success',
  Icon: /*#__PURE__*/_jsx(SafeIcon, {
    Icon: LearningLight,
    className: "tw-text-current",
    size: 24
  }, "Hana_Categories_LearningLight")
}, {
  variant: 'info',
  Icon: /*#__PURE__*/_jsx(SafeIcon, {
    Icon: ClimaLight,
    className: "tw-text-current",
    size: 24
  }, "Hana_Categories_ClimaLight")
}, {
  variant: 'primary',
  Icon: /*#__PURE__*/_jsx(SafeIcon, {
    Icon: DesempenoLight,
    className: "tw-text-current",
    size: 24
  }, "Hana_Categories_DesempenoLight")
}];
export var adaptToTopicCards = function adaptToTopicCards(categories) {
  return categories.map(function (category, index) {
    return _objectSpread(_objectSpread({}, category), APPEND_DATA[index] || APPEND_DATA[index % APPEND_DATA.length]);
  });
};
export var adaptToPrompt = function adaptToPrompt(categories) {
  if ((categories === null || categories === void 0 ? void 0 : categories.length) > 0) {
    return categories.map(function (category, index) {
      return _objectSpread({
        category: category.name || ''
      }, index < APPEND_DATA.length ? APPEND_DATA[index] : APPEND_DATA[index % APPEND_DATA.length]);
    });
  }
  return [];
};